<template>
  <PageLayout class="success-page">
    <PageHeader
      :title="$t(`Common.title.homeTitle`)"
      :breadcrumb="[
        {
          title: `${$t('Common.title.homeTitle')}`,
        },
        {
          title: `${$t(
            `Common.title.${this.applyData.typeName}`
          )}`,
        },
      ]"
    />
    <m-form ref="form">
      <div class="banner">
        <div class="pa-4">
          <h1 class="server__title">
            <svg
              t="1652756910240"
              class="qrcode"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1268"
              width="200"
              height="200"
            >
              <path
                d="M511.434623 63.564711c-247.428276 0-448.010617 200.582341-448.010617 448.01164 0 247.430322 200.581318 448.01164 448.010617 448.01164 247.432369 0 448.012663-200.581318 448.012663-448.01164C959.447287 264.147052 758.865969 63.564711 511.434623 63.564711zM773.519714 382.576325 447.871959 704.039781 245.771031 507.044128l63.996546-68.093864 138.15964 138.15964 261.086343-261.087367L773.519714 382.576325z"
                p-id="1269"
                :fill="'#13a07b'"
              ></path>
            </svg>
            <span> {{ $t('Common.message.submitSuccess') }} </span>
          </h1>
        </div>
      </div>

      <!-- 基本信息 -->
      <template>
        <m-folding-panel
          :title="$t(`apply.title.applyInfo`)"
          enableCollapsed
          :active="true"
          :class="`rainbow__folding__panel rainbow__page1 pl-4 pr-4 pb-8`"
        >
          <div
            :style="{
              'flex-direction': is_mobile() ? 'column' : 'row',
              display: 'flex',
            }"
          >
            <m-cell>
              <m-cell-item
                :label="$t('apply.title.applyType')"
                :value="
                  form.applicationType ? this.$t(`apply.title.${form.applicationType}`) : ''"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.companyType')"
                :value="getCompanyType(form.companyType)"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.applyCaseNo')"
                :value="form.applicationNo"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.approvalStatus')"
                :value="
                  form.status ? `${this.$t(`statusType.${form.status}`)}` : ''
                "
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.surname')"
                :value="form.surname"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.givenName')"
                :value="form.givenName"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.companyName')"
                :value="form.companyName"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.venueName')"
                :value="form.siteName"
              ></m-cell-item>
            </m-cell>
          </div>
          <div
            style="
              flex-direction: row;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            {{ getResultTip(form?.status, form?.companyType) }}
          </div>
        </m-folding-panel>
      </template>
    </m-form>
    <template slot="actions">
      <m-button size="large" @click="mainMenuClick" class="mr-4">{{
        this.$t('Common.action.complete')
      }}</m-button>
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/Layout/web/PageLayout.vue';
import { ApplyAPI } from '@/api';
import { is_mobile, getCompanyType, getResultTip } from 'govmo-common/src/utils/utils';
import SuccessImg from 'common/assets/images/success.png';
import PageHeader from 'common/components/Layout/web/PageHeader.vue';

export default {
  components: {
    PageLayout,
    PageHeader
  },
  props: {
    formData: {
      type: Object,
    },
  },
  data() {
    return {
      form: {},
      applyData: {},
      SuccessImg,
    };
  },
  methods: {
    is_mobile,
    getCompanyType,
    getResultTip,
    async getApplyData() {
      try {
        this.$showLoading();
        let data = await ApplyAPI.QueryDetail(
          this.applyData?.cardNoOrTaxNo,
          this.applyData?.applicationNo,
          this.applyData?.expire,
          this.applyData?.signature
        );
        this.form = { ...this.applyData, ...data };
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    mainMenuClick() {
      this.$router.push('/');
    },
  },
  async created() {
    this.applyData = { ...this.$route.params.formData };
    console.log('====5', this.applyData);
    this.getApplyData();
  },
};
</script>
<style lang="scss" scoped>
.cellWidth {
  .m-cell__value {
    word-wrap: break-word !important;
  }
}
.btnDiv {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-bottom: 10px;
  margin-top: 20px;
}
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.server__title {
  text-align: center;
  color: #13a07b;
  font-size: 28px;
}
.server__title {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 0 16px;
  // border-bottom: 1px solid #d1d1d6;
  img,
  svg {
    width: 70px;
    height: 70px;
    margin-right: 20px;
    object-fit: contain;
  }
  span {
    font-weight: bold;
  }
}
</style>